import { render, staticRenderFns } from "./CombinedTaxInvoicePdf.vue?vue&type=template&id=4118c4cb&"
import script from "./CombinedTaxInvoicePdf.vue?vue&type=script&lang=js&"
export * from "./CombinedTaxInvoicePdf.vue?vue&type=script&lang=js&"
import style0 from "./CombinedTaxInvoicePdf.vue?vue&type=style&index=0&id=4118c4cb&prod&lang=scss&"
import style1 from "./CombinedTaxInvoicePdf.vue?vue&type=style&index=1&id=4118c4cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports